/**
 * '오늘 아침 자동 작업' 카드의 "실패 N건 보기" → 반영 로그를 그 실패만 걸러 연다(유저 플로우 제안 1, 2026-11-03).
 * 앱은 라우터 없이 사이드바 state 로 화면을 바꾸므로, 여는 쪽이 한 번짜리 힌트(sessionStorage)를 남기고 반영 로그가 처음 그릴 때
 * 읽고 지운다(매장 가격 요청의 storePrice:openTab 과 같은 방식). 저장소를 못 쓰면 반영 로그는 평소처럼 연다.
 */
export const SYNC_LOG_OPEN_KEY = 'syncLog:openFilter';

export interface SyncLogOpenFilter {
  /** yyyy-MM-dd — 그 하루의 기록만. */
  date:    string | null;
  /** 반영 로그의 jobType(반영 방식 필터). */
  jobType: string;
  /** 어떤 아침 단계에서 왔는지 — 안내 문구용. */
  label:   string;
  /**
   * 아침 체인 단계(SYNC_STOCK · UPDATE_PRICES · AUTO_INCREASE) — 반영 로그의 '실패 N건 다시 돌리기'(백엔드 PR #95)가 어느 단계를
   * 다시 돌릴지. 상승분 자동 반영의 카드별 실패는 SYNC_NAVER(③ 과 같은 jobType)로 남아 jobType 만으로는 알 수 없다. 옛 힌트는 없음.
   */
  step?:   string | null;
}

/**
 * 아침 체인 단계 → 그 단계의 실패가 남는 반영 로그 jobType(백엔드 UpdatePricesJob · SyncStockJob · SyncNaverJob).
 * 상승분 자동 반영(AUTO_INCREASE)의 카드별 실패는 SYNC_NAVER 로 남는다(SYNC_NAVER_AUTO 는 요약 한 줄). 시세 분류(CLASSIFY_DROPS)의
 * '실패' 칸은 확인 필요 수라 실패 목록이 없다.
 */
export const CHAIN_STEP_LOG_JOB: Record<string, string> = {
  SYNC_STOCK:    'SYNC_STOCK',
  UPDATE_PRICES: 'UPDATE_PRICES',
  AUTO_INCREASE: 'SYNC_NAVER',
};

export function writeSyncLogFilter(f: SyncLogOpenFilter): void {
  try {
    sessionStorage.setItem(SYNC_LOG_OPEN_KEY, JSON.stringify(f));
  } catch {
    // 저장소 없음 — 반영 로그는 평소처럼 연다.
  }
}

/** 읽기만 한다(렌더 중에 불러도 되게 — 지우기는 clearSyncLogFilter 로 마운트 뒤에). 모양이 다르면 없음. */
export function readSyncLogFilter(): SyncLogOpenFilter | null {
  try {
    const raw = sessionStorage.getItem(SYNC_LOG_OPEN_KEY);
    if (raw == null) return null;
    const v = JSON.parse(raw) as Partial<SyncLogOpenFilter> | null;
    if (!v || typeof v.jobType !== 'string' || v.jobType === '') return null;
    const date = typeof v.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v.date) ? v.date : null;
    return {
      date, jobType: v.jobType, label: typeof v.label === 'string' ? v.label : '',
      step: typeof v.step === 'string' && v.step !== '' ? v.step : null,
    };
  } catch {
    return null;
  }
}

export function clearSyncLogFilter(): void {
  try {
    sessionStorage.removeItem(SYNC_LOG_OPEN_KEY);
  } catch {
    // 저장소 없음
  }
}
